export enum ETipoEndereco {
    Principal = 1,
    Entrega = 2,
    Cobranca = 3,
    Pessoal = 4,
    Comercial = 5,
    Outros = 6
}
